export enum TransactionAccountMode {
  ADHOC = 'adhoc',
  DEFINED = 'defined',
}
